import { authHttp } from '../http'
import * as routes from '../../routes/checklist-operacional.routes'
import { errorHandler } from '../../../util/error.service'

export async function getChecklists(tpId) {
  try {
    const { data } = await authHttp().get(routes.urlGetChecklists(tpId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getChecklist(tpId, id) {
  try {
    const { data } = await authHttp().get(routes.urlGetChecklist(tpId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveChecklist(tpId, checklist) {
  try {
    const { data } = checklist.id
      ? await authHttp().put(routes.urlPutChecklist(tpId, checklist.id), checklist)
      : await authHttp().post(routes.urlPostChecklist(tpId), checklist)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
